import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { register } from 'swiper/element/bundle';
import { CommonModule } from '@angular/common';
import { PortalModule } from '@angular/cdk/portal';
import { SharedCoreModule } from 'src/app/shared-core/shared-core.module';
import { SwiperDirective } from 'src/app/shared-core/directives/swiper.directive';
import { FrequentlyBoughtTogetherComponent } from './frequently-bought-together/frequently-bought-together.component';
import { ProductRecommendationsComponent } from './product-recommendations/product-recommendations.component';
import { RelatedProductsComponent } from './related-products/related-products.component';
import { TrendingProductsComponent } from './trending-products/trending-products.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { AddToCartConfirmationDialogComponent } from '../add-to-cart-confirmation-dialog/add-to-cart-confirmation-dialog.component';
import { ServicePlansRowComponent } from '../service-plans-row/service-plans-row.component';
import { ReviewStarsComponent } from '../review-stars/review-stars.component';
register();

@NgModule({
    declarations: [
        SwiperDirective,
        FrequentlyBoughtTogetherComponent,
        RelatedProductsComponent,
        TrendingProductsComponent,
        ProductRecommendationsComponent,
        ProductCardComponent,

        // Below components do not belong here,
        // but Shared Module imports & exports this module
        // Therefore, it should be OK...
        ReviewStarsComponent,
        AddToCartConfirmationDialogComponent,
        ServicePlansRowComponent
    ],
    imports: [BrowserModule, CommonModule, SharedCoreModule, PortalModule],
    exports: [
        FrequentlyBoughtTogetherComponent,
        RelatedProductsComponent,
        TrendingProductsComponent,
        ProductRecommendationsComponent,
        ProductCardComponent,

        // Below components do not belong here,
        // but Shared Module imports & exports this module
        // Therefore, it should be OK...
        ReviewStarsComponent,
        AddToCartConfirmationDialogComponent,
        ServicePlansRowComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ProductRecommendationsModule {}
